import React, { useEffect, useState, useCallback } from "react";

import FormControl from "@material-ui/core/FormControl";
import { makeStyles } from "@material-ui/core/styles";
import { ErrorMessage, getIn } from "formik";
import Select from "react-select";

import TextError from "./TextError";

const OutlineSearchable = (props) => {
  const classes = useStyles();
  const [warn, setWarn] = useState(false);
  const [value, setValue] = useState(false);

  const errorStyle = useCallback(() => {
    if (getIn(props.form.errors, props.field.name)) {
      setWarn(true);
    } else {
      setWarn(false);
    }
  }, [props.form.errors, props.field.name]);

  useEffect(() => {
    errorStyle();
  }, [errorStyle]);

  const handleValue = (value) => {
    setValue(value);
    props.onChange(value);
  };

  return (
    <FormControl className={classes.selectWrapper} id={props.id}>
      <label className={value ? "active" : ""}>{props.label}</label>
      <Select
        {...props}
        name={props.field.name}
        className={
          !props.disabled && warn ? classes.errorContent : classes.selectContent
        }
        id={props.field.name}
        onChange={(value) => handleValue(value)}
        placeholder={props.placeholder}
        isDisabled={props.disabled}
        isMulti={props.isMulti}
        options={props.options}
        error={warn}
        styles={customStyles}
        theme={(theme) => ({
          ...theme,

          colors: {
            ...theme.colors,
            primary25: "#9ac156",
            primary: "#658D1B",
            neutral90: "#9bb100",
          },
        })}
      />

      <ErrorMessage name={props.field.name} component={TextError} />
    </FormControl>
  );
};
const customStyles = {
  control: (base) => ({
    ...base,
    height: 55,
    minHeight: 55,
  }),
};
const useStyles = makeStyles((theme) => {
  return {
    selectWrapper: {
      width: "100%",
      position: "relative",
      "& label": {
        position: "absolute",
        top: "0",
        fontSize: ".7rem",
        padding: "0 3px",
        marginLeft: "10px",
        zIndex: 10,
        backgroundColor: "transparent",
        color: "transparent",
        transitions: ".3s all easy",
        "&.active": {
          top: "-7px",
          color: "rgba(0, 0, 0, 0.54)",
          backgroundColor: "white",
        },
      },
    },
    errorText: {
      paddingLeft: 18,
      top: "-7px",
      color: theme.palette.error.main,
    },
    selectContent: {
      width: "100%",
      borderStyle: "none",
      borderWidth: "0px",
    },
    errorContent: {
      width: "100%",
      borderColor: theme.palette.error.main,
      borderStyle: "solid",
      borderWidth: "1px",
    },
  };
});

export default OutlineSearchable;
